import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueCookies from 'vue3-cookies'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// language file
import i18n from './i18n.js'

import Utils from '@/features/Utils.js'
import AppConfig from '@/App.Config.js'
var gConfig = AppConfig();

import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import Mixin from '@/features/Mixin.js'


window['_U'] = Utils();
window['gAppInfo'] = {
	version: process.env.VUE_APP_VERSION,
	mode: process.env.VUE_APP_BUILD_MODE,
};

if(gConfig.isProd) {
	console.log=function() {};
}

const firebaseConfig = {
	apiKey: "AIzaSyCUVWWjOJrSHhSG3QGnQGzzpgJLMMW7G_U",
	authDomain: "dvision-world.firebaseapp.com",
	projectId: "dvision-world",
	storageBucket: "dvision-world.appspot.com",
	messagingSenderId: "620693569405",
	appId: "1:620693569405:web:7dfaf41053b0d929e89614",
	measurementId: "G-RZ6093MPXL"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// mobile event
import Vue3TouchEvents from 'vue3-touch-events'

// const requireComponent = require.context(
// 	'./components',
// 	false,
// 	/Base[A-Z]\w+\.(vue|js)$/
// )

// init data - jhk
_U.getInitializeData((landInfo, config, itemData, languageData) => {
	store.state.config = config;
	store.state.itemData = itemData;
	store.state.languageData = languageData;
	const app = createApp(App, { DVILand: landInfo })
	app.mixin(Mixin).use(i18n).use(store).use(router).use(VueCookies).mount('#app')
});

// const app = createApp(App, { DVILand: landInfo})
// window.DVW = app

// requireComponent.keys().forEach((fileName) => {
// 	const componentConfig = requireComponent(fileName)
// 	const componentName = upperFirst(
// 		camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
// 	)
// 	app.component(componentName, componentConfig.default || componentConfig)
// })

// app.use(i18n).use(store).use(router).use(Vue3TouchEvents).mount('#app')
// cookie expireTime 10 minutes
// app.mixin(Mixin).use(i18n).use(store).use(router).use(VueCookies).mount('#app')
// app.use(i18n).use(store).use(router).mount('#app')
